import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchProductionOutsourceList = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/productionOutsource/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            if(res.data.try_again) {
                dispatch('fetchProductionOutsourceList', payload)
            } else {
                commit('setProductionOutsourceList', res.data)         
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchProductionOutsourceData = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/productionOutsource/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            
            commit('setProductionOutsourceData', {response: res.data.response})   
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetProductionOutsourceData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchProductionOutsourceData_ItemList = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/productionOutsource/singleItemList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        commit('setProductionOutsourceDataItemList', res.data.response)            
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitProductionOutsourceData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
    
    axios.post('/productionOutsource/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {     
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            dispatch('fetchProductionOutsourceData', {id: res.data.id})
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        //commit('toggleLoadingState', false)
    })
}

export const deleteProductionOutsourceData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/productionOutsource/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchProductionOutsourceList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/productionOutsource/actions.js